import React from 'react';
import styled from 'styled-components/macro';

import { Spinner } from '../../Spinner/Spinner';

interface Props {
  text?: string;
  height?: string;
}

const LoadingIndicator: React.FC<Props> = ({ text, height }) => {
  return (
    <SpinnerContainer height={height}>
      <Spinner text={text ?? ''} />
    </SpinnerContainer>
  );
};

const SpinnerContainer = styled.div<Pick<Props, 'height'>>`
  display: flex;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.4);
  align-items: center;
  position: relative;
  width: 100%;
  height: ${({ height }) => height ?? '100vh'};
  text-align: center;
`;

export default LoadingIndicator;
